import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { Col, Container, Row } from 'react-bootstrap';
import { PortableContentWithLinks } from 'src/components/PortableContentWithLinks/PortableContentWithLinks';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import imgFallback from 'src/utils/image';
import * as classes from './Article.module.scss';

export const Article = ({ _rawHeader: header, _rawContent: content, image, linkColor }) => (
  <Container as="section" className="py-6">
    <PortableHeader content={header} className={classes.header} />
    <Row noGutters>
      <Col xs={12} className="d-lg-block mt-4">
        <Col xs={12} className="px-0">
          <Row noGutters className="mt-5">
            <Col xs={12} lg={6} className="align-self-start text-center">
              <GatsbyImage
                style={{ borderRadius: '10px' }}
                className="shadow-image"
                alt={image?.alt ?? ''}
                image={image?.image?.asset?.gatsbyImageData ?? imgFallback}
              />
            </Col>
            <Col xs={12} lg={6} className="align-self-center px-md-4 text-muted px-2 py-5 pl-0">
              <PortableContentWithLinks value={content} linkColor={linkColor} />
            </Col>
          </Row>
        </Col>
      </Col>
    </Row>
  </Container>
);

Article.propTypes = {
  _rawHeader: PropTypes.arrayOf(PropTypes.shape({ _key: PropTypes.string, _type: PropTypes.string, image: PropTypes.shape({}) }))
    .isRequired,
  _rawContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  image: PropTypes.shape({}).isRequired,
};
